import { render, staticRenderFns } from "./DataTableFilter.vue?vue&type=template&id=6bab472c&scoped=true&"
import script from "./DataTableFilter.vue?vue&type=script&lang=js&"
export * from "./DataTableFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bab472c",
  null
  
)

export default component.exports